import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { money } from "@/lib/api";

export const ProductCard = ({ product, index = 0, tall = false }) => {
  return (
    <motion.div
      data-testid={`product-card-${product.id}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1], delay: (index % 3) * 0.08 }}
      className="group"
    >
      <Link to={`/piece/${product.id}`} className="block">
        <div className={`relative overflow-hidden bg-[#0a0a0a] ${tall ? "aspect-[3/4]" : "aspect-square"}`}>
          <img
            src={product.image}
            alt={product.title}
            className="img-zoom h-full w-full object-cover"
          />
          <div className="absolute left-0 top-0 flex items-center gap-2 px-4 py-3">
            <span className="bg-black/50 px-2 py-1 text-[9px] uppercase tracking-[0.3em] text-gold backdrop-blur-sm">
              {product.edition}
            </span>
          </div>
          {product.sold && (
            <div className="absolute inset-0 flex items-center justify-center bg-black/70">
              <span className="font-serif-lux text-2xl italic text-[#f5f5f0]">Acquired</span>
            </div>
          )}
        </div>
        <div className="flex items-start justify-between gap-4 pt-4">
          <div>
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#52525b]">{product.maker}</p>
            <h3 className="font-serif-lux mt-1 text-2xl font-light leading-tight text-[#f5f5f0]">
              {product.title}
            </h3>
          </div>
          <p className="whitespace-nowrap pt-1 text-sm font-light text-[#a1a1aa]">
            {money(product.price, product.currency)}
          </p>
        </div>
      </Link>
    </motion.div>
  );
};
